import { 
    UPDATE_PAGE_NEXT_PAGE,
    UPDATE_MY_COMPETITIONS_FILTER_TYPE,
    UPDATE_FILTER_NAME, 
} from './types'
import { 
  COMPETITIONS_OPEN, 
  COMPETITIONS_LOST, 
  COMPETITIONS_GAVEN_UP 
} from '../global/enums'

const myCompState = {
        project_name: '',
        types: [
            { name: 'Em aberto', selected: true, icon: 'pending', key: COMPETITIONS_OPEN },
            { name: 'Perdidas', selected: false, icon: 'sentiment_dissatisfied', key: COMPETITIONS_LOST },
            { name: 'Desistiu', selected: false, icon: 'pan_tool', key: COMPETITIONS_GAVEN_UP }
        ],
        limit: 20,
        page: 1,
        nextPage: null
}

const filterReducer = (state, actions) => {

    const { type, payload } = actions

    switch (type) {
        case UPDATE_PAGE_NEXT_PAGE: {
            return {
              ...state,
              page: payload.page,
              nextPage: payload.nextPage
            }
        }
        case UPDATE_MY_COMPETITIONS_FILTER_TYPE: {
          return {
            ...state,
            types: payload 
          }
        }
        case UPDATE_FILTER_NAME: {
          return {
              ...state,
              project_name: payload,
          }
        }
        default: {
          return state
        }
    }

}

export { filterReducer as default, myCompState }